import { StoreFacade } from "../../core/store/facade/store-facade";
import { VasAppFacade } from "../services/vas-app-facade.service";
import { VasStore } from "../store/store-type";

export class VasStoreFacade extends StoreFacade {

    constructor(protected appFacade: VasAppFacade, protected storeService: VasStore) {
        super(appFacade, storeService);
    }

}



// WEBPACK FOOTER //
// ./src/vas/facades/vas-store-facade.ts